import { produce } from 'immer';
import { Builder, parseStringPromise } from 'xml2js';

async function colorizeSvg(svg: string, fillColor: string, backgroundColor?: string) {
  // parse SVG XML to a JS object
  const originalSvgObject: SvgXmlObj = await parseStringPromise(svg, {
    normalizeTags: true,
    trim: true,
    attrNameProcessors: [
      (name: string) => {
        // Removes fill attributes by renaming the attribute, but only if fillColor is given
        if (fillColor !== null && name === 'fill') {
          // We keep the original fill renamed as 'data-original-fill' in case someone needs to reconstruct the original svg
          return 'data-original-fill';
        }
        return name;
      },
    ],
  }).catch(err => {
    console.error(err);
    return svg;
  });

  // prepare base SVG construct with applied fill and background color
  const baseSvgObject: SvgXmlObj = {
    svg: {
      $: {},
      rect: [
        {
          $: {
            class: 'bs_il_svg_background',
            x: 0,
            y: 0,
            width: '100%',
            height: '100%',
            fill: backgroundColor || 'none',
          },
        },
      ],
      g: [{ $: { class: 'bs_il_svg_fill', fill: fillColor } }],
    },
  };

  // walk through all elements from original object and inject them into <g>
  const mergedSvgObject = produce(baseSvgObject, draft => {
    Object.entries(originalSvgObject.svg).forEach(([key, content]) => {
      if (key === '$') {
        // This is where we could remove the width and height attribute from SVG.
        // But since we support having those values set in SVGs we no longer need to remove them.
        // Code here is keept for future use cases where we might want to strip other attributes
        // // const { height: _height, width: _width, ...svgAttrs } = content as SvgObjAttributes;
        // // draft.svg.$ = svgAttrs;
        draft.svg.$ = content as SvgObjAttributes;
      } else {
        draft.svg.g[0][key] = content;
      }
    });
  });

  // rebuild SVG XML from js object
  const builder = new Builder();
  return builder.buildObject(mergedSvgObject);
}

export default colorizeSvg;
